import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { Globe, Settings } from 'lucide-react';

const APINode = ({ data, selected }) => {
  const [showConfig, setShowConfig] = useState(false);
  
  return (
    <>
      <div className={`px-4 py-2 shadow-md rounded-lg bg-indigo-500 text-white border-2 ${
        selected ? 'border-indigo-300' : 'border-indigo-600'
      }`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Globe className="h-4 w-4" />
            <div className="text-sm font-medium">{data.label}</div>
          </div>
          <button
            onClick={() => setShowConfig(true)}
            className="p-1 hover:bg-indigo-600 rounded"
          >
            <Settings className="h-3 w-3" />
          </button>
        </div>
        
        {data.config?.method && (
          <div className="text-xs mt-1 opacity-90">
            {data.config.method}: {data.config.endpoint}
          </div>
        )}
        
        <Handle
          type="target"
          position={Position.Top}
          style={{
            background: '#6366f1',
            border: '2px solid #4f46e5',
          }}
        />
        <Handle
          type="source"
          position={Position.Bottom}
          style={{
            background: '#6366f1',
            border: '2px solid #4f46e5',
          }}
        />
      </div>

      {showConfig && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-lg font-semibold mb-4">Configure API Node</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">HTTP Method</label>
                <select className="mt-1 w-full border rounded-lg px-3 py-2">
                  <option>GET</option>
                  <option>POST</option>
                  <option>PUT</option>
                  <option>PATCH</option>
                  <option>DELETE</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">API Endpoint</label>
                <input 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="https://api.example.com/endpoint"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Headers</label>
                <textarea 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder='{"Authorization": "Bearer {{token}}", "Content-Type": "application/json"}'
                  rows="3"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Request Body</label>
                <textarea 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder='{"key": "{{variable}}"}'
                  rows="4"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Response Variable</label>
                <input 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="Variable name to store API response"
                />
              </div>
              <div className="flex items-center space-x-2">
                <input type="checkbox" className="rounded" />
                <label className="text-sm text-gray-700">Retry on failure</label>
              </div>
            </div>
            <div className="flex justify-end space-x-2 mt-6">
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 border rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default APINode;